import { Segment, SegmentOptions } from '@/core/api/entities/radio/segment'

import { SegmentResponseDTO } from '@core/api/dtos/response/radio/segment'
import { SongMapper } from '@core/api/mappers/song/songMapper'

import { SegmentStatMapper } from './segmentStatMapper'

export class SegmentMapper {
	static toEntity(data: SegmentResponseDTO): Segment {
		return new Segment({
			id: data.id,
			description: data.description,
			startAt: data.start_at,
			endAt: data.end_at,
			priority: data.priority,
			type: data.type,
			crossfade: data.crossfade,
			mirrorId: data.mirror_id,
			rotateAutomatically: data.rotate_automatically,
			songsCount: data.songs_count,
			size: data.size,
			size2: data.size2,
			size3: data.size3,
			length: data.length,
			artists: data.artists,
			dirtyAnalytics: data.dirty_analytics,
			totalGeneratedSongs: data.total_generated_songs,
			droppedSongs: data.dropped_songs,
			feedbackDropRatio: data.feedback_drop_ratio,

			options: data.options ? SegmentOptions.create(data.options) : null,
			stats: SegmentStatMapper.toEntities(data.stats),
			songs: data.songs?.data
				? SongMapper.toEntities(data.songs.data)
				: undefined,
		})
	}

	static toEntities(data: SegmentResponseDTO[]): Segment[] {
		return data.map((segment) => this.toEntity(segment))
	}
}
